import {
  useMemo,
  useContext
} from 'react'
import DOMPurify from 'isomorphic-dompurify'
import { CaptionsContext } from '@src/context/CaptionsContext'
import { WorkWithParsedSrts } from '../pages/api/work/[id]'
import { useMultilingualCaptions } from '../context/LanguageContext'

type TranscriptPresentationProps = {
  work?: WorkWithParsedSrts;
}

export const TranscriptPresentation: React.FC<TranscriptPresentationProps> = (
  { work }: TranscriptPresentationProps
) => {
  const multilingualCaptions = useMultilingualCaptions(work)
  const { captionSize } = useContext(CaptionsContext)
  const sanitizedTranscript = useMemo(() => {
    let parsedSrt = ''
    try {
      const parsed: { id: number; start: number; end: number; text: string }[] | string = multilingualCaptions?.parsedSrt || ''
      parsedSrt = Object.values(parsed).reduce((acc, val) => `${acc} <br /> ${val.text}`, '')
    } catch (err) {
      // todo; probably not what we want to show the end user
      parsedSrt = `Failed to parse SRT: ${String(err)}`
    }

    return DOMPurify.sanitize(parsedSrt)
  }, [multilingualCaptions])

  return (
    <div className="scroll" style={{ fontSize: `${captionSize}em` }}>
      <div dangerouslySetInnerHTML={{ __html: sanitizedTranscript }} />
    </div>
  )
}

export default TranscriptPresentation
